import {
  FETCH_PROMOTION_PRODUCTS_FAILURE,
  FETCH_EMPTY_SEARCH_LIST, FETCH_PROMOTION_PRODUCTS_REQUEST,
  FETCH_PROMOTION_PRODUCTS_SUCCESS,
  FETCH_SOP_PROFILE_FAILURE,
  FETCH_SOP_PROFILE_REQUEST,
  FETCH_SOP_PROFILE_SUCCESS,
  GET_PROMOTION_SEARCH_KEYWORDS, GET_PROMOTION_SEARCH_KEYWORDS_FAILURE, GET_PROMOTION_SEARCH_KEYWORDS_SUCCESS, GET_PROMOTION_SEARCH_PRODUCTS,
  GET_PROMOTION_SEARCH_PRODUCTS_FAILURE,
  GET_PROMOTION_SEARCH_PRODUCTS_SUCCESS,
  FETCH_REGULAR_PRODUCT_CATEGORY_REQUEST,
  FETCH_REGULAR_PRODUCT_CATEGORY_SUCCESS,
  FETCH_REGULAR_PRODUCT_CATEGORY_FAILURE,
  FETCH_REGULAR_PRODUCT_SUB_CATEGORY_REQUEST,
  FETCH_REGULAR_PRODUCT_SUB_CATEGORY_SUCCESS,
  FETCH_REGULAR_PRODUCT_SUB_CATEGORY_FAILURE,
  FETCH_REGULAR_PRODUCT_REQUEST,
  FETCH_REGULAR_PRODUCT_SUCCESS,
  FETCH_REGULAR_PRODUCT_FAILURE,
  GET_PRODUCT_DETAIL_REQUEST,
  GET_PRODUCT_DETAIL_SUCCESS,
  GET_PRODUCT_DETAIL_FAILURE,
} from "../actions";
import { PROMOTION_GROUP_MAPPING } from "../common/commonConstant";

const initialState = {
  PROMOTION: {
    loading: false,
    promotionProducts: null,
    nonPromotionProducts: null,
    error: null
  },
  SOP: {
    loading: false,
    purchased: [],
    notPurchase: [],
  },
  PROMOTION_SEARCH: {
    searchProductsLoading: false,
    searchSuggestionLoading: false,
    promotionSearchProducts: { data: [], total: 0, totalPages: 0 },
    promotionSearchKeywords: null,
    error: null
  },
  REGULAR_CATEGORY: {
    loading: false,
    data: [],
    SUB_CATEGORY: {
      loading: true,
      data: {},
    },
    PRODUCTS: {
      loading: false,
      data: {},
    },
  },
  PRODUCT_DETAIL: {
    loading: false,
    productDetailData: {},
    error: null
  },
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_PROMOTION_PRODUCTS_REQUEST:
      return { ...state, PROMOTION: { ...state.PROMOTION, loading: true, error: null } };
    case FETCH_PROMOTION_PRODUCTS_SUCCESS:
      const keyName = PROMOTION_GROUP_MAPPING[action.payload.type].dataName;
      return {
        ...state,
        PROMOTION: {
          ...state.PROMOTION, [keyName]: {
            ...action.payload.data,
            products: [...state.PROMOTION[keyName] ? state.PROMOTION[keyName].products : [],
            ...action.payload.data.products]
          },
          loading: false, error: null
        },
      };
    case FETCH_PROMOTION_PRODUCTS_FAILURE:
      return { ...state, PROMOTION: { ...state.PROMOTION, loading: true, error: action.payload } };

    case FETCH_REGULAR_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state, REGULAR_CATEGORY:
          { ...state.REGULAR_CATEGORY, loading: true, error: null }
      };
    case FETCH_REGULAR_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY,
          ...action.payload.data,
          loading: false, error: null
        }
      };
    case FETCH_REGULAR_PRODUCT_CATEGORY_FAILURE:
      return {
        ...state, REGULAR_CATEGORY:
          { ...state.REGULAR_CATEGORY, loading: true, error: action.payload }
      };

    case FETCH_REGULAR_PRODUCT_SUB_CATEGORY_REQUEST:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY, SUB_CATEGORY: {
            ...state.REGULAR_CATEGORY.SUB_CATEGORY,
            loading: true, error: null
          }
        }
      };
    case FETCH_REGULAR_PRODUCT_SUB_CATEGORY_SUCCESS:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY, SUB_CATEGORY: {
            ...state.REGULAR_CATEGORY.SUB_CATEGORY, data: {
              ...state.REGULAR_CATEGORY.SUB_CATEGORY.data,
              [action.payload.categoryId]: action.payload.data.data
            },
            loading: false, error: null,
          }
        }
      };
    case FETCH_REGULAR_PRODUCT_SUB_CATEGORY_FAILURE:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY, SUB_CATEGORY: {
            ...state.REGULAR_CATEGORY.SUB_CATEGORY,
            loading: false, error: action.payload
          }
        }
      }
    case FETCH_REGULAR_PRODUCT_REQUEST:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY, PRODUCTS: {
            ...state.REGULAR_CATEGORY.PRODUCTS,
            loading: action.payload.params.currentPage === 1, error: null
          }
        }
      };

    case FETCH_REGULAR_PRODUCT_SUCCESS:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY, PRODUCTS: {
            data: {
              ...state.REGULAR_CATEGORY.PRODUCTS.data,
              [action.payload.params.categoryId]: {
                ...action.payload.data,
                data: state.REGULAR_CATEGORY.PRODUCTS.data[action.payload.params.categoryId] ?
                  [...state.REGULAR_CATEGORY.PRODUCTS.data[action.payload.params.categoryId]?.data, ...action.payload.data?.data] :
                  action.payload.data?.data
              }
            },
            loading: false, error: null
          },
        },
      };

    case FETCH_REGULAR_PRODUCT_FAILURE:
      return {
        ...state, REGULAR_CATEGORY: {
          ...state.REGULAR_CATEGORY, PRODUCTS: {
            ...state.REGULAR_CATEGORY.PRODUCTS,
            loading: false, error: action.payload
          }
        }
      };

    case "RESET_REGULAR_PRODUCT_QUANTITIES": {
      const newState = { ...state };

      const productsData = newState.REGULAR_CATEGORY.PRODUCTS.data;

      Object.keys(productsData || {}).forEach((subCategoryId) => {
        const subCatProducts = productsData[subCategoryId]?.data || [];
        productsData[subCategoryId] = {
          ...productsData[subCategoryId],
          data: subCatProducts.map((product) => ({
            ...product,
            quantity: 0,
          })),
        };
      });

      return newState;
    }

    case FETCH_SOP_PROFILE_REQUEST:
      return { ...state, SOP: { ...state.SOP, loading: true, error: null } };

    case FETCH_SOP_PROFILE_SUCCESS:
      return {
        ...state, SOP: {
          ...state.SOP, [action?.payload?.type]: {
            ...action.payload.data,
          },
          loading: false, error: null
        }
      };
    case FETCH_SOP_PROFILE_FAILURE:
      return { ...state, SOP: { ...state.SOP, loading: true, error: action.payload } };
    case GET_PROMOTION_SEARCH_PRODUCTS:
      return { ...state, PROMOTION_SEARCH: { ...state.PROMOTION_SEARCH, searchProductsLoading: true, error: null } };
    case GET_PROMOTION_SEARCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        PROMOTION_SEARCH: {
          ...state.PROMOTION_SEARCH,
          promotionSearchProducts: {
            data: [...state.PROMOTION_SEARCH.promotionSearchProducts.data, ...action.payload.data],
            total: action.payload.total,
            totalPages: action.payload.totalPages
          },
          searchProductsLoading: false,
          error: null
        }
      };
    case GET_PROMOTION_SEARCH_PRODUCTS_FAILURE:
      return { ...state, PROMOTION_SEARCH: { ...state.PROMOTION_SEARCH, searchProductsLoading: false, error: action.payload } };
    case FETCH_EMPTY_SEARCH_LIST:
      return {
        ...state,
        PROMOTION_SEARCH: {
          ...state.PROMOTION_SEARCH,
          promotionSearchProducts: {
            data: [],
            total: 0,
            totalPages: 0
          },
          searchProductsLoading: false
        }
      };
    case GET_PROMOTION_SEARCH_KEYWORDS:
      return {
        ...state,
        PROMOTION_SEARCH: {
          ...state.PROMOTION_SEARCH,
          searchSuggestionLoading: true,
          error: null
        }
      };
    case GET_PROMOTION_SEARCH_KEYWORDS_SUCCESS:
      return {
        ...state,
        PROMOTION_SEARCH: {
          ...state.PROMOTION_SEARCH, promotionSearchKeywords: action.payload, searchSuggestionLoading: false, error: null
        }
      };
    case GET_PROMOTION_SEARCH_KEYWORDS_FAILURE:
      return {
        ...state,
        PROMOTION_SEARCH: {
          ...state.PROMOTION_SEARCH,
          searchSuggestionLoading: false,
          error: action.payload
        }
      };
    case GET_PRODUCT_DETAIL_REQUEST:
      return {
        ...state,
        PRODUCT_DETAIL: {
          ...state.PRODUCT_DETAIL,
          loading: true,
          error: null
        }
      };
    case GET_PRODUCT_DETAIL_SUCCESS:
      return {
        ...state,
        PRODUCT_DETAIL: {
          ...state.PRODUCT_DETAIL, productDetailData: action.payload, loading: false, error: null
        }
      };
    case GET_PRODUCT_DETAIL_FAILURE:
      return {
        ...state,
        PRODUCT_DETAIL: {
          ...state.PRODUCT_DETAIL,
          loading: false,
          error: action.payload
        }
      };
    default:
      return state;
  }
}